module.exports = __webpack_public_path__ + "media/images/flavours/icon-sous-bois_dark-1e2d7c2f2923ec4d9f098654f90ab8c2.png";